export function runInsideLock(callback: CallableFunction) {
  // @ts-ignore: ignore type missmatch, because LockGrantedCallback is not importable
  return navigator.locks.request('SamoletOAuthLib', callback);
}
